import { UIBrick, registerBrick } from 'olympe';
import React, {useState} from 'react';
import ReactDOM from 'react-dom';
import { SKUDataGrid } from './SKUDataGrid.jsx'
import PropTypes from 'prop-types'
import {combineProps, createEvents} from '../shared/_helpers';

export default class SKU extends UIBrick {

    /**
     * This method runs when the brick is ready in the HTML DOM.
     * @override
     * @param {!BrickContext} context
     * @param {!Element} elementDom
     */
    draw(context, elementDom) {

        /* Write your code here. You have to implement this method ! */
        const events = createEvents([
            {
                name: 'fetchData',
                event: context.getEvent('Fetch Data'),
                before: (event, values) => {
                    context.getProperty('Data').set(values)
                },
            },
            {
                name: 'throwError',
                event: context.getEvent('Throw Error'),
                before: (event, values) => {
                    context.getProperty('Error Message').set(values)
                },
            },
        ])

        const reload = context.getProperty('Reload')
        const filters = context.getProperty('Filters').observe()
        const setReload = value => {
            context.getProperty('Reload').set(value)
        }

        combineProps([
            { name: 'searchText', prop: context.getProperty('Search Text'), defaultValue: '' },
            { name: 'hidden', prop: context.getProperty('Hidden'), defaultValue: true },
        ]).subscribe(
            props => {
                if (props.hidden === false) {
                    ReactDOM.render(
                        <SKU.Component
                            {...props}
                            {...events}
                            context={context}
                            reload={reload}
                            filters={filters}
                            setReload={setReload}
                        />,
                        elementDom
                    )
                }
            }
        )
    }
}

SKU.Component = props => {
    const [rows, setRows] = useState([])

    return [
        <SKUDataGrid
            key={'dataGrid'}
            filters={props.filters}
            reload={props.reload}
            setReload={props.setReload}
            multipleEdit={props.multipleEdit}
            throwError={props.throwError}
            searchText={props.searchText}
            rows={rows}
            setRows={setRows}
        />
    ]
}

SKU.Component.propTypes = {
    searchText: PropTypes.string,
    reload: PropTypes.object,
    filters: PropTypes.object,
    setReload: PropTypes.func,
    multipleEdit: PropTypes.func,
    throwError: PropTypes.func,
}

registerBrick('017e4e599141f9ce75da', SKU);
